import { applyMiddleware, combineReducers, createStore } from 'redux';
import thunk from 'redux-thunk';
import { authMobileReducer as authReducer } from './authMobileReducer';
import { sharedRelayVariablesReducer } from './sharedRelayVariablesReducer';
import { sharedIntlVariablesReducer } from './sharedIntlVariablesReducer';
import dblReducers from 'dibs-buyer-layout/src/reducers';

/**
 * Local `app-buyer-finding` reducers that should be used across the app.
 */
export const defaultReducers = {
    authReducer,
    relayVariables: sharedRelayVariablesReducer,
    intlVariables: sharedIntlVariablesReducer,
};

/**
 * Creates a redux store and applys additional middleware. Defaults to creating a store with all reducers.
 *
 * Shouldn't be used on responsive entry files!!! The store there is coming from the DBL.
 */
export function createReduxStore(additionalReducers = {}, state = {}) {
    // TODO: Get rid of the DBL reducers here
    const reducers = combineReducers({ ...defaultReducers, ...dblReducers, ...additionalReducers });
    return createStore(reducers, state, applyMiddleware(thunk));
}
